export enum OverlayAnimationStateEnum {
    open = 'open',
    close = 'close'
}
